var e="undefined"!=typeof Blob?Blob:null;export{e as default};
